import { AutoMap } from "@automapper/classes";
import { Temporal } from "@js-temporal/polyfill";
import { InterventionEntity } from "../db/db";
import { InterventionDTO } from "../services/dto/intervention.dto";
import { mapper } from "../tools/mapping/mapper";
import { MeasureEau } from "./EAU/measure-eau";
import { EInterventionStatus } from "./enums/intervention-status";
import { ETimeSlot } from "./enums/time-slot";
import { MeasureLingette } from "./Lingette/measure-lingette";
import { MeasureMassif } from "./Massif/measure-massif";
import { Process } from "./process";
import { SamplingPoint } from "./sampling-point";
import { User } from "./user";
import { Zone } from "./zone";
import { AreaMap } from "./area-map";
import { MesureAdduction } from "./Adduction-air/mesure-adduction";
import { MeasureGeneric } from "./measure-generic";

export class Intervention {

    /** ID SERVER */
    @AutoMap()
    Code!: number;
    @AutoMap()
    Status!: EInterventionStatus;
    @AutoMap()
    Comment?: string;
    @AutoMap()
    PlannedOn!: Temporal.PlainDateTime;
    @AutoMap()
    TimeSlotPlannedOn!: ETimeSlot;

    @AutoMap()
    SamplingPoint: SamplingPoint = new SamplingPoint();
    @AutoMap()
    Sampler: User = new User();

    @AutoMap()
    Contact: User = new User();

    @AutoMap(() => [Zone])
    ZoneList: Zone[] = [];

    @AutoMap(() => [Process])
    ProcessList: Process[] = [];

    @AutoMap(() => [MeasureEau])
    MesureEauList: MeasureEau[] = [];

    @AutoMap(() => [MeasureMassif])
    MesureMassifList: MeasureMassif[] = [];

    @AutoMap(() => [MeasureLingette])
    MesureLingetteList: MeasureLingette[] = [];

    @AutoMap(() => [MesureAdduction])
    MesureAdductionAirList: MesureAdduction[] = []

    @AutoMap(() => [MeasureGeneric])
    MesureGeneriqueList: MeasureGeneric[] = []


    // NEW FEATURE
    @AutoMap(() => [AreaMap])
    LingetteAreaMapTerrainList: AreaMap[] = [];

    @AutoMap(() => [AreaMap])
    MassifAreaMapTerrainList: AreaMap[] = [];
    //

    /**
     * Liste des zones et processus
     */
    // ZPList: Array<Zone | Process> = [];

    @AutoMap()
    SituationPlan?: AreaMap;
    @AutoMap()
    StrategyId!: number;
    @AutoMap()
    Redactor!: string
    @AutoMap()
    ClientName!: string

    public constructor(init?: Partial<Intervention>) {
        Object.assign(this, init);
    }

    get HasPose() {
        return this.ZoneList.map(x => x.ZoneMesureList).flat().filter(y => !y.IsDepose).length;
    }

    get HasDePose() {
        return this.ZoneList.map(x => x.ZoneMesureList).flat().filter(y => y.IsDepose).length;
    }

    get HasNoZone() {
        return this.ZoneList.length === 0;
    }

    get StaticPumpWithBatteryPose() {
        return this.ZoneList.map(x => x.ZoneMesureList).flat().filter(y => y.PumpWithBattery === true && !y.IsDepose).length;
    }

    get StaticPumpWithBatteryDepose() {
        return this.ZoneList.map(x => x.ZoneMesureList).flat().filter(y => y.PumpWithBattery === true && y.IsDepose).length;
    }

    get StaticPumpWithPowerSupplyPose() {
        return this.ZoneList.map(x => x.ZoneMesureList).flat().filter(y => y.PumpWithBattery === false && !y.IsDepose).length;
    }

    get StaticPumpWithPowerSupplyDepose() {
        return this.ZoneList.map(x => x.ZoneMesureList).flat().filter(y => y.PumpWithBattery === false && y.IsDepose).length;
    }

    get PumpOnOperator() {
        return this.ProcessList.map(x => x.ProcessMesure.ProcessOperatorList.map(y => y.CassetteList.map(z => z.Pompe))).flat(2).length;
    }

    get MeasureForPoseWithFan() {
        return this.ZoneList.map(x => x.ZoneMesureList).flat().filter(y => !y.IsDepose && y.HasFan).length;
    }

    get MeasureForDeposeWithFan() {
        return this.ZoneList.map(x => x.ZoneMesureList).flat().filter(y => y.IsDepose && y.HasFan).length;
    }

    static mapFromJSON(json: InterventionDTO): Intervention {
        let int = new Intervention;

        int = mapper.map(json, InterventionDTO, Intervention);
        // a.Id = json['id'];
        // a.Name = json['name'];
        // a.ChipName = json['chipName'];
        // a.Type = json['type'];
        // a.MeasureCategory = json['measureCategory'];
        return int;
    }
}